// Generator gambar invoice (canvas) FASNET FIBER + unduh & share WhatsApp.
import { toast } from "sonner";
import { api } from "./api";

const SATUAN = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan", "Sepuluh", "Sebelas"];

export function terbilang(n) {
  const inner = (v) => {
    v = Math.floor(Math.abs(Number(v) || 0));
    if (v === 0) return "";
    if (v < 12) return SATUAN[v];
    if (v < 20) return inner(v - 10) + " Belas";
    if (v < 100) return inner(Math.floor(v / 10)) + " Puluh " + inner(v % 10);
    if (v < 200) return "Seratus " + inner(v - 100);
    if (v < 1000) return inner(Math.floor(v / 100)) + " Ratus " + inner(v % 100);
    if (v < 2000) return "Seribu " + inner(v - 1000);
    if (v < 1000000) return inner(Math.floor(v / 1000)) + " Ribu " + inner(v % 1000);
    if (v < 1000000000) return inner(Math.floor(v / 1000000)) + " Juta " + inner(v % 1000000);
    if (v < 1000000000000) return inner(Math.floor(v / 1000000000)) + " Milyar " + inner(v % 1000000000);
    return "";
  };
  const t = inner(n).replace(/\s+/g, " ").trim();
  return (t || "Nol") + " Rupiah";
}

const rp = (n) => "Rp " + new Intl.NumberFormat("id-ID").format(Number(n) || 0);
const BULAN = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
export const bulanTagihan = (isoDate) => {
  const d = isoDate ? new Date(isoDate) : new Date();
  return isNaN(d) ? `${BULAN[new Date().getMonth()]} ${new Date().getFullYear()}` : `${BULAN[d.getMonth()]} ${d.getFullYear()}`;
};
const tglID = (d) => {
  const x = d ? new Date(d) : new Date();
  return isNaN(x) ? "-" : `${x.getDate()} ${BULAN[x.getMonth()]} ${x.getFullYear()}`;
};

let logoPromise = null;
const loadLogo = () => {
  if (!logoPromise) {
    logoPromise = new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = () => resolve(null);
      img.src = "/logo.png";
    });
  }
  return logoPromise;
};

// Nomor invoice tetap per pelanggan per bulan tagihan (disimpan server): DDYYYY + 5 digit acak.
export async function fetchInvoiceNo(pelanggan, expDate) {
  const d = expDate ? new Date(expDate) : new Date();
  const bulan = (isNaN(d) ? new Date() : d).toISOString().slice(0, 7);
  try {
    const { data } = await api.get("/portal/invoice-number", { params: { pelanggan: String(pelanggan || "-"), bulan } });
    if (data?.no) return data.no;
  } catch { /* gunakan fallback lokal */ }
  const n = new Date();
  return `${String(n.getDate()).padStart(2, "0")}${n.getFullYear()}${String(Math.floor(Math.random() * 100000)).padStart(5, "0")}`;
}

// Jatuh tempo invoice = tanggal expired secret pelanggan (fallback: hari ini).
export function jatuhTempo10(expDate) {
  const d = expDate ? new Date(String(expDate).slice(0, 10) + "T00:00:00") : new Date();
  const b = isNaN(d) ? new Date() : d;
  return new Date(b.getFullYear(), b.getMonth(), b.getDate()).toISOString();
}

const fit = (x, text, cx, cy, maxW, size, weight = "400") => {
  let s = size;
  x.font = `${weight} ${s}px Arial`;
  while (s > 13 && x.measureText(text).width > maxW) { s -= 1; x.font = `${weight} ${s}px Arial`; }
  x.fillText(text, cx, cy);
};

// inv: { no, nama, alamat, paket, bulan, harga, ppn, total, tanggal, jatuh_tempo, catatan }
export async function buildInvoiceCanvas(inv) {
  const W = 1240, H = 1754;
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const x = c.getContext("2d");
  const NAVY = "#0a3d91", DARKNAVY = "#071c3d", RED = "#e11d2e", CYAN = "#19b5e8", LIGHT = "#eef4fb", GRAY = "#5b6472";
  const logo = await loadLogo();

  // latar + pita atas
  x.fillStyle = "#ffffff"; x.fillRect(0, 0, W, H);
  x.fillStyle = DARKNAVY; x.fillRect(0, 0, W, 190);
  x.strokeStyle = CYAN; x.lineWidth = 3;
  for (let i = 0; i < 5; i++) {  // aksen garis fiber
    x.beginPath(); x.moveTo(W * 0.62 + i * 26, 0); x.quadraticCurveTo(W * 0.8 + i * 20, 95, W, 40 + i * 26); x.stroke();
  }
  x.beginPath(); x.moveTo(0, 186); x.quadraticCurveTo(W * 0.5, 213, W, 180); x.strokeStyle = RED; x.lineWidth = 7; x.stroke();
  // logo asli FASNET FIBER
  x.textAlign = "left"; x.textBaseline = "alphabetic";
  if (logo) {
    const lh = 102, lw = (lh * logo.width) / logo.height;
    x.drawImage(logo, 70, 40, lw, lh);
    x.font = "400 17px Arial"; x.fillStyle = "#c9d6ea";
    x.fillText("I N T E R N E T   F O R   E V E R Y O N E", 74, 172);
  }

  let y = 270;
  // judul INVOICE
  x.font = "900 96px Arial Black, Arial"; x.fillStyle = NAVY; x.fillText("INVOICE", 70, y + 40);
  x.fillStyle = RED; x.fillRect(72, y + 58, 105, 10);
  x.fillStyle = CYAN; x.fillRect(187, y + 58, 105, 10);
  y += 120;

  // blok perusahaan (kiri)
  x.font = "700 30px Arial"; x.fillStyle = DARKNAVY; x.fillText("PT FASNET SKY FIBER", 130, y);
  x.fillStyle = GRAY;
  fit(x, "Komplek Bumi Ayu Lestari B14, Kuala Dua", 130, y + 38, 540, 23);
  fit(x, "Kec. Sungai Raya, Kab. Kubu Raya, Kalimantan Barat", 130, y + 70, 540, 23);
  fit(x, "Telp/WA: 0898 535 4000", 130, y + 112, 540, 23);
  fit(x, "Email: fasnetwifi@gmail.com", 130, y + 146, 540, 23);
  // ikon bulat
  [y + 104, y + 138].forEach((cy) => { x.beginPath(); x.arc(100, cy, 17, 0, 7); x.fillStyle = NAVY; x.fill(); });
  // kotak meta (kanan)
  const bx = 690, bw = 480;
  x.fillStyle = LIGHT; x.strokeStyle = "#c9d6ea"; x.lineWidth = 2;
  x.beginPath(); x.roundRect(bx, y - 30, bw, 190, 18); x.fill(); x.stroke();
  x.font = "700 26px Arial"; x.fillStyle = NAVY;
  x.fillText("No. Invoice", bx + 40, y + 18);
  x.fillText("Tanggal", bx + 40, y + 62);
  x.fillText("Jatuh Tempo", bx + 40, y + 106);
  x.fillStyle = DARKNAVY;
  fit(x, ":  " + (inv.no || "-"), bx + 220, y + 18, bw - 240, 22);
  fit(x, ":  " + tglID(inv.tanggal), bx + 220, y + 62, bw - 240, 22);
  fit(x, ":  " + (inv.jatuh_tempo ? tglID(inv.jatuh_tempo) : "-"), bx + 220, y + 106, bw - 240, 22);
  y += 210;

  // Kepada Yth
  x.fillStyle = NAVY; x.beginPath(); x.roundRect(70, y, 250, 46, 12); x.fill();
  x.font = "700 28px Arial"; x.fillStyle = "#ffffff"; x.fillText("Kepada Yth.", 100, y + 33);
  x.fillStyle = LIGHT; x.beginPath(); x.roundRect(70, y + 46, W - 140, 112, 12); x.fill();
  x.font = "400 26px Arial"; x.fillStyle = GRAY;
  x.fillText("Nama", 100, y + 92); x.fillText("Alamat", 100, y + 134);
  x.fillStyle = DARKNAVY;
  fit(x, ":  " + (inv.nama || "-"), 220, y + 92, 920, 27, "700");
  fit(x, ":  " + (inv.alamat || "-"), 220, y + 134, 920, 26);
  y += 198;

  // tabel item
  const speed = /(\d+)\s*Mbps/i.exec(inv.paket || "");
  const layanan = speed ? `Internet ${speed[1]}Mbps` : "Internet WiFi Rumahan";
  x.fillStyle = NAVY; x.fillRect(70, y, W - 140, 52);
  x.font = "700 26px Arial"; x.fillStyle = "#ffffff";
  x.fillText("No", 92, y + 35); x.fillText("Deskripsi", 320, y + 35);
  x.fillText("Qty", 672, y + 35); x.fillText("Harga Satuan", 810, y + 35); x.fillText("Jumlah", 1035, y + 35);
  const rows = [
    ["1", layanan, "1", rp(inv.harga), rp(inv.harga)],
    ["2", "PPN", "-", rp(inv.ppn || 0), rp(inv.ppn || 0)],
  ];
  rows.forEach((r, i) => {
    const ry = y + 52 + i * 56;
    x.fillStyle = i % 2 ? "#f7fafd" : "#ffffff"; x.fillRect(70, ry, W - 140, 56);
    x.strokeStyle = "#d7e2ef"; x.lineWidth = 1.5; x.strokeRect(70, ry, W - 140, 56);
    x.fillStyle = DARKNAVY; x.font = "400 25px Arial";
    x.fillText(r[0], 92, ry + 37);
    fit(x, r[1], 175, ry + 37, 450, 25);
    x.textAlign = "center"; x.fillText(r[2], 715, ry + 37);
    x.textAlign = "right"; x.fillText(r[3], 985, ry + 37); x.fillText(r[4], 1155, ry + 37);
    x.textAlign = "left";
  });
  y += 52 + rows.length * 56 + 30;

  // pembayaran + total
  x.fillStyle = NAVY; x.beginPath(); x.roundRect(70, y, 240, 46, 12); x.fill();
  x.font = "700 28px Arial"; x.fillStyle = "#ffffff"; x.fillText("Pembayaran", 96, y + 33);
  x.fillStyle = LIGHT; x.beginPath(); x.roundRect(70, y + 46, 560, 150, 12); x.fill();
  x.font = "400 25px Arial"; x.fillStyle = GRAY;
  x.fillText("Bank", 100, y + 92); x.fillText("No. Rek", 100, y + 132); x.fillText("Atas Nama", 100, y + 172);
  x.fillStyle = DARKNAVY; x.font = "700 25px Arial";
  x.fillText(":  BCA", 250, y + 92);
  x.fillText(":  029 990 4000", 250, y + 132);
  x.fillText(":  Fasnet Sky Fiber", 250, y + 172);

  const tx = 700, tw = 470;
  const diskon = inv.diskon || 0;
  x.font = "400 27px Arial"; x.fillStyle = DARKNAVY;
  x.fillText("Subtotal", tx, y + 20); x.textAlign = "right"; x.fillText(":  " + rp(inv.harga), tx + tw, y + 20); x.textAlign = "left";
  x.fillText(diskon ? "Kode Unik (−)" : "Diskon", tx, y + 62); x.textAlign = "right"; x.fillText(":  " + rp(diskon), tx + tw, y + 62); x.textAlign = "left";
  x.fillStyle = NAVY; x.beginPath(); x.roundRect(tx - 20, y + 82, tw + 20, 62, 10); x.fill();
  x.font = "900 34px Arial"; x.fillStyle = "#ffffff";
  x.fillText("Total", tx, y + 126); x.textAlign = "right"; x.fillText(":  " + rp(inv.total), tx + tw, y + 126); x.textAlign = "left";
  y += 230;

  // terbilang
  x.fillStyle = LIGHT; x.beginPath(); x.roundRect(70, y, W - 140, 62, 12); x.fill();
  x.strokeStyle = "#c9d6ea"; x.stroke();
  x.font = "700 26px Arial"; x.fillStyle = NAVY; x.fillText("Terbilang:", 96, y + 40);
  x.font = "italic 400 25px Arial"; x.fillStyle = DARKNAVY;
  x.fillText(terbilang(inv.total), 240, y + 40);
  y += 105;

  // catatan + tanda tangan
  x.fillStyle = NAVY; x.beginPath(); x.roundRect(70, y, 200, 44, 12); x.fill();
  x.font = "700 26px Arial"; x.fillStyle = "#ffffff"; x.fillText("Catatan", 100, y + 32);
  x.fillStyle = LIGHT; x.beginPath(); x.roundRect(70, y + 44, 600, 130, 12); x.fill();
  x.font = "400 23px Arial"; x.fillStyle = GRAY;
  const catatan = inv.catatan || "Transfer ke rekening BCA di atas, atau bayar lewat Portal Konsumen FASNET. Konfirmasi pembayaran via WhatsApp 0898 535 4000.";
  const words = catatan.split(" ");
  let line = "", ly = y + 84;
  for (const w of words) {
    if (x.measureText(line + w).width > 560) { x.fillText(line, 96, ly); ly += 32; line = ""; }
    line += w + " ";
  }
  x.fillText(line.trim(), 96, ly);
  x.font = "700 26px Arial"; x.fillStyle = DARKNAVY;
  x.fillText("Hormat Kami,", 900, y + 70);
  x.strokeStyle = DARKNAVY; x.lineWidth = 2; x.beginPath(); x.moveTo(860, y + 190); x.lineTo(1150, y + 190); x.stroke();
  x.font = "700 28px Arial"; x.fillText("FASNET FIBER", 900, y + 224);

  // footer
  x.fillStyle = DARKNAVY; x.beginPath(); x.moveTo(0, H - 90); x.quadraticCurveTo(W * 0.5, H - 160, W, H - 60); x.lineTo(W, H); x.lineTo(0, H); x.fill();
  x.strokeStyle = RED; x.lineWidth = 6; x.beginPath(); x.moveTo(0, H - 92); x.quadraticCurveTo(W * 0.5, H - 162, W, H - 62); x.stroke();
  x.font = "italic 700 30px Georgia"; x.fillStyle = "#ffffff"; x.fillText("Terima kasih atas kepercayaan Anda", 70, H - 45);
  return c;
}

const invFileName = (inv) => `Invoice-FASNET-${(inv.nama || "pelanggan").replace(/\s+/g, "-")}-${(inv.bulan || "").replace(/\s+/g, "-")}.png`;

export async function downloadInvoice(inv) {
  const c = await buildInvoiceCanvas(inv);
  c.toBlob((blob) => {
    if (!blob) { toast.error("Gagal membuat gambar invoice"); return; }
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = invFileName(inv);
    a.click();
    URL.revokeObjectURL(a.href);
    toast.success("Invoice diunduh");
  }, "image/png");
}

export async function shareInvoiceWA(inv) {
  const c = await buildInvoiceCanvas(inv);
  const text = [
    `Invoice FASNET FIBER — ${inv.paket || "WiFi Rumahan"} (${inv.bulan})`,
    `Pelanggan: ${inv.nama}`,
    `Total: ${rp(inv.total)}${inv.diskon ? ` (tarif ${rp(inv.harga)} − kode unik ${inv.diskon})` : " (PPN Rp 0)"}`,
    "Transfer: BCA 029 990 4000 a.n. Fasnet Sky Fiber",
  ].join("\n");
  c.toBlob(async (blob) => {
    if (!blob) { toast.error("Gagal membuat gambar invoice"); return; }
    const file = new File([blob], invFileName(inv), { type: "image/png" });
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      try {
        await navigator.share({ files: [file], text, title: "Invoice FASNET FIBER" });
        toast.success("Invoice dibagikan");
      } catch (err) {
        if (err?.name !== "AbortError") toast.error("Gagal membagikan invoice");
      }
    } else {
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = file.name;
      a.click();
      URL.revokeObjectURL(a.href);
      window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank");
      toast.info("Invoice diunduh — lampirkan ke chat WhatsApp yang terbuka");
    }
  }, "image/png");
}
